import { WAIT_UNITS, type WaitUnit } from "@velizhanin-dev/bot-scenario"
import { Input } from "@/shared/ui/input"
import { NativeSelect } from "@/shared/ui/native-select"
import { parseOptionalNumber } from "./editor-props"
import type { DurationDraft } from "./lib/duration-draft"

export const WAIT_UNIT_LABELS: Record<WaitUnit, string> = {
	seconds: "секунд",
	minutes: "минут",
	hours: "часов",
	days: "дней",
}

/** Число и единица времени; для паузы: обязательно, для таймаута: включается отдельно. */
export function DurationInputs({
	value,
	onChange,
	label,
}: {
	value: DurationDraft
	onChange: (value: DurationDraft) => void
	label: string
}) {
	return (
		<div className="grid grid-cols-2 gap-2">
			<Input
				type="number"
				min={1}
				aria-label={`${label}: сколько`}
				placeholder="10"
				value={value.amount ?? ""}
				onChange={(event) =>
					onChange({ ...value, amount: parseOptionalNumber(event.target.value) })
				}
			/>
			<NativeSelect
				aria-label={`${label}: единица`}
				value={value.unit ?? "hours"}
				onChange={(event) => onChange({ ...value, unit: event.target.value as WaitUnit })}
			>
				{WAIT_UNITS.map((unit) => (
					<option key={unit} value={unit}>
						{WAIT_UNIT_LABELS[unit]}
					</option>
				))}
			</NativeSelect>
		</div>
	)
}
